export default "__VITE_ASSET__CzFwDZw4__"